import {BaseRepository} from '../orm';

/**
 * A registred Repository decorator
 * @param {T} Constructor
 * @return {any}
 */
export function RegistieredRepository<T extends { new(...args: any[]): any }>(
    Constructor: T
) {
  console.log('REGISTER');
  BaseRepository.registerRepositoryByName(Constructor.name, Constructor);

  return class extends Constructor {
    newProperty = 'new property';
    hello = 'override';
  };
}
